export default "__VITE_ASSET__BJ3r3w0V__"